var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconLanguageSelect = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-42.534 -33.065)" },
                React.createElement("g", { transform: "translate(44.553 34.435)" },
                    React.createElement("line", { x1: "0.9", y1: "14.1", x2: "5", y2: "1.8" }),
                    React.createElement("line", { x1: "9.6", y1: "14.1", x2: "5.6", y2: "1.8" }),
                    React.createElement("line", { strokeLinecap: "butt", x1: "1.8", y1: "9.6", x2: "8.3", y2: "9.6" })),
                React.createElement("g", { id: "Gruppe_1233", transform: "translate(58.153 44.4)" },
                    React.createElement("path", { d: "M0.7,15.5c0,0,1.6-0.7,2.1-3.7s0-10,0-10" }),
                    React.createElement("line", { x1: "2.7", y1: "1.8", x2: "11.3", y2: "1.8" }),
                    React.createElement("path", { d: "M11.3,1.8c0,0,0.1,6.2,0.1,9.6s-3.8,2.4-3.8,2.4" }),
                    React.createElement("line", { strokeLinecap: "butt", x1: "3.4", y1: "9.9", x2: "10.6", y2: "9.9" }),
                    React.createElement("line", { strokeLinecap: "butt", x1: "3.4", y1: "5.8", x2: "10.6", y2: "5.8" }))),
            React.createElement("path", { d: "M12.6,4c2.3-0.5,4.6-0.3,6.8,0.5c2.1,0.9,3.8,2.3,5,4.2" }),
            React.createElement("path", { d: "M12.4,24.9c-1.5-0.4-2.9-1.1-4.1-2.1c-1.2-1.1-2.1-2.4-2.8-3.8" }),
            React.createElement("path", { strokeLinejoin: "round", strokeMiterlimit: "4.0005", d: "M8.7,19.6L5.3,19l-0.6,3.4" }),
            React.createElement("path", { strokeLinejoin: "round", strokeMiterlimit: "4.0005", d: "M21,8.3l3.4,0.6L25,5.6" }))));
});
export default IconLanguageSelect;
//# sourceMappingURL=IconLanguageSelect.js.map